import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { 
    checkBlackbaudRequirementAsync, 
    fetchBlackbaudFinalReportRefAsync, 
    fetchBlackbaudPaymentRefAsync, 
    fetchBlackbaudProgressReportRefAsync, 
    fetchBlackbaudRequestRefAsync, 
    selectAnyProgressReportsStatus, 
    selectbbgCheckLoading, 
    selectFinalReportStatus, 
    selectOldBudgetApplicationId, 
    selectPaymentsLoading, 
    selectRequestStatus, 
    selectRequirementStatus } 
    from "../Common/stateSlices/bbgDataSlice";
import { 
    addNewFinalReport, 
    addNewProgressReport, 
    fetchBudgetIdAsync, 
    selectBudgetLoading, 
    selectFinalReportId, 
    selectProgressReportKeys, 
    selectProgressReports,
    setCurrentRequirement 
} from "../Common/stateSlices/budgetStateSlice";
import { Alert, AlertTitle, Box, Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { LoadingIcons } from "../Common/LoadingIcons";
import { setLoadingState } from "../Common/stateSlices/appStateSlice";

export const RequirementsLoading = ({id, reqId, reqType}) => {
  const dispatch = useAppDispatch();
  //selectors
  const bbgCheckLoading = useAppSelector(selectbbgCheckLoading);
  const requestStatus = useAppSelector(selectRequestStatus);
  const budgetLoading = useAppSelector(selectBudgetLoading);
  const oldBudgetApplicationId = useAppSelector(selectOldBudgetApplicationId);
  const progressReports = useAppSelector(selectProgressReports);
  const finalReport = useAppSelector(selectFinalReportId);
  const finalReportExists = finalReport !== 0 && finalReport !== null && finalReport !== undefined;
  const anyProgressReportStatus = useAppSelector(selectAnyProgressReportsStatus);
  const progressReportKeys = useAppSelector(selectProgressReportKeys);
  const finalReportLoading = useAppSelector(selectFinalReportStatus);
  const requirementStatus = useAppSelector(selectRequirementStatus)
  const paymentsLoaded = useAppSelector(selectPaymentsLoading);

  const  progressReportsLoaded: boolean = (anyProgressReportStatus === "loaded"|| anyProgressReportStatus === "none")
  const progressLoaded: boolean = (
    progressReportsLoaded &&
    requestStatus === "loaded" &&
    budgetLoading === "loaded" &&
    paymentsLoaded === "loaded" &&
    (finalReportLoading === "loaded" || finalReportLoading === "none")
  );

  const finalLoaded: boolean = (
    progressReportsLoaded &&
    requestStatus === "loaded" &&
    budgetLoading === "loaded" &&
    paymentsLoaded === "loaded" &&
    finalReportLoading === "loaded"
  );

  switch(reqType){
    case "progress":
      if(progressLoaded) {
        dispatch(setLoadingState("loaded"));
      }
      break;
    case "final":
      if(finalLoaded) {
        dispatch(setLoadingState("loaded"));
      }
      break;
    default:
      break;
  }


  //check if there the requirement matches the id - also returns this requirement data  
  useEffect(()=> {
    dispatch(setLoadingState("loading"));
    dispatch(setCurrentRequirement(reqId));
    dispatch( checkBlackbaudRequirementAsync({id, reqId}) )
  }, 
  [id]);



  //get request, existing progress reports, and budget if requirement passes checks
  useEffect(() => {
    if(bbgCheckLoading !== "success") {
      console.log("Requirement check not loaded, skipping budget and request load")
      return;
    }
    if(bbgCheckLoading === "success"){
        dispatch(fetchBlackbaudRequestRefAsync({id})); // get request data
        dispatch(fetchBlackbaudPaymentRefAsync(id)); // get payment data
    }
    if (reqType === "progress") {
      console.log("Loading Progress Report Budget")
    }
  }, 
  [bbgCheckLoading])

  // after request is loaded, get budget (old or new application ids);
    useEffect(() => {
    if (requestStatus === "loaded"){
      if (id.length > 10){
        dispatch(fetchBudgetIdAsync({id: oldBudgetApplicationId, admin: true, budgetKey: ""}));
      } else {
        dispatch(fetchBudgetIdAsync({id, admin: true, budgetKey: ""}));
      }
    }
  }, [requestStatus])

    // when budget is loaded, check if progress report exists on budget, and then get progress reports and final reports
  useEffect(()=> {
    console.log("budget loading in use effect: ", budgetLoading);
      if (budgetLoading === "new"){
        dispatch(fetchBudgetIdAsync({id: oldBudgetApplicationId, admin: true, budgetKey: ""})); // load new budget if new application id exists
        return
      }


    if (budgetLoading === "loaded"){ //load existing progress reports
        progressReportKeys.map((key) => {
          dispatch(fetchBlackbaudProgressReportRefAsync(key)); 
        });
        dispatch(fetchBlackbaudProgressReportRefAsync(reqId))

      console.log("Loading progress and final reports", reqType, finalReportExists);
      switch(reqType){ // for progress and final, if new create in slice
        case "progress":
            !progressReports.includes(reqId) &&  dispatch(addNewProgressReport());
            if(finalReportExists){ // load existing final report when it exists
              dispatch(fetchBlackbaudFinalReportRefAsync(reqId));
            }
          break;
        case "final":
          console.log("Final Reports")
          dispatch(fetchBlackbaudFinalReportRefAsync(reqId));
          if(!finalReportExists){ 
            console.log("Creating new final report for reqId", reqId);
            dispatch(addNewFinalReport(reqId))
          }; // create new final report if it does not exist
          break;
        default:
          console.log("Unknown requirement type", reqType);
      }
    }

  }, [budgetLoading]) // budget exists

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <Typography variant="h4">Loading your budget...</Typography>
      {/* loading screen */} 
                <Dialog
                  open={true}
                  id="definition"
                >
                  <DialogTitle sx={{color: "primary"}}>Loading</DialogTitle>
                  <DialogContent>
                    <Stack spacing={2}>
                        <LoadingIcons state={budgetLoading} loadingTarget="Budget Data"/>
                        <LoadingIcons state={requestStatus} loadingTarget="Request Data"/>
                        {requestStatus === "loaded" && anyProgressReportStatus !== "none" &&
                        <>
                          <LoadingIcons state={anyProgressReportStatus} loadingTarget="Progress Reports" />
                          <Stack spacing={1.3} sx={{paddingLeft: "20px"}}>
                              {progressReportKeys.map(key => {  return <LoadingIcons key={key} state={requirementStatus(key)} loadingTarget={`Progress Report ${key}`} />}  )}
                          </Stack>
                        </>}
                        <LoadingIcons state={finalReportLoading} loadingTarget="Final Report"/>
                      {anyProgressReportStatus === "loaded" && <LoadingIcons state={paymentsLoaded} loadingTarget="Payments Data"/>}
                    </Stack>
                    { (requestStatus === "failed"  ||  budgetLoading === "failed" || anyProgressReportStatus === "failed" || paymentsLoaded ==="failed") && 
                      <Stack>
                        <Alert severity="error">
                          <AlertTitle>Uh oh... it looks like there was an issue loading some of your data.</AlertTitle>
                          You appear to have an issue loading the following items.
                          <ul>
                            {requestStatus === "failed" && <li>Request</li> }
                            {budgetLoading === "failed" && <li>Budget</li>}
                            {anyProgressReportStatus === "failed" && <li>Progress Reports</li>}
                            {paymentsLoaded === "failed" && <li>Payments</li>}
                            {false && <li>Final Report</li>}
                          </ul>
                          Please try to first refresh this screen. If the problem persists, please reach out to your contact at the Duke Endowment with which item or items are not loading. 
                        </Alert>
                      </Stack>
                    }
      
                  </DialogContent>
                </Dialog>
    </Box>
  );
}
